export default "__VITE_ASSET__NSRvpDPE__"